module.exports = __webpack_public_path__ + "img/update50.8d45c9f4.svg";